import { IProduct } from '../../../../../data/api/models';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import * as Commonmark from 'react-commonmark';
import { FaQuestionCircle } from 'react-icons/fa';
import * as React from 'react';
import { get } from 'lodash';

export const renderProductDefinition = (product: IProduct) => (name: string, useProvidedString?: string) => {
  const definition = useProvidedString ? useProvidedString : product.metadata.definitions[name];
  let className;

  if (!definition) {
    return null;
  }

  const popover = (
    <Popover
      id={`popover-${name}`}
    >
      <Commonmark source={definition}/>
    </Popover>
  );

  className = (name === 'region' || name === 'destinations') ? 'info-btn no-margin' : 'info-btn';

  return (
    <OverlayTrigger
      trigger="click"
      rootClose={true}
      overlay={popover}
      placement="bottom"
      positionLeft={200}
      positionTop={50}
    >
      <FaQuestionCircle data-d={name}
                        className={className}/>
    </OverlayTrigger>
  );
}

interface IMedCriricalAnswers {
  waitingListAnswer: boolean
  terminalAnswer: boolean
}

export const mtaMedicalDeclarationQuestionAnswers = (formValues): IMedCriricalAnswers => {

  const mtcChannels = ['mtc', 'mtc-renewal']
  const isMTCChannel = mtcChannels.includes(get(formValues, 'metadata.sales_channel', ''))
  const currentAwaitingAnswer = get(formValues, 'metadata.medical_declaration_questions.is-awaiting-medical-investigation-treatment.answer', get(formValues, `metadata.medical_declaration_questions.[${isMTCChannel ? '3' : '4'}].answer`, false));
  const currentTerminalAnswer = get(formValues, 'metadata.medical_declaration_questions.is-terminal.answer', get(formValues, `metadata.medical_declaration_questions.[${isMTCChannel ? '4' : '5'}].answer`, false));

  return {
    waitingListAnswer: currentAwaitingAnswer,
    terminalAnswer: currentTerminalAnswer
  }

}
